import { Box, Grid, MenuItem, Select, TextField, Stack, Button } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { NameRegex, No_special_regex } from '../../Utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from '../../Redux/AxiosInstance';
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';

function AddDevice() {

    const navigate = useNavigate()
    const initialDeviceData = {
        name: "",
        ip: "",
        user_name: "",
        device_placement: "",
        password: "",
        
    }
    const [PersonalDetailsData, setPersonalDetailsData] = useState({
        ...initialDeviceData
      });

      const {id} = useParams();
      const location = useLocation();
      const {deviceData} = location.state || {};

      useEffect(() => {
        if(id && deviceData){
            setPersonalDetailsData({
                name: deviceData.name || "",
                ip: deviceData.ip || "",
                user_name: deviceData.user_name || "",
                device_placement: deviceData.device_placement || "",
                building_id: deviceData?.building || deviceData?.common_building || "",
            });
        }
      }, [id, deviceData]);

      // console.log(PersonalDetailsData)


      const [loading, setLoading] = useState(false)
      const [listBuilding, setListBuilding] = useState([])
      const [deviceList, setDeviceList] = useState([])

      // const deviceList = [
      //     {
      //         id : 1,
      //         name : 'Facial Recognition (FR) & Quick Response (QR)',
      //     },
      //     {
      //         id : 3,
      //         name : 'Automatic Number Plate Recognition (ANPR)',
      //     }
      // ]

      const [errtext, seterrtext] = useState({
        PersonalDetailsData: {},
      });

      // console.log(errtext)
      const getAllVisitors = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}all_list_building`)
          // console.log(response)
          if(response.status === 200){
            setListBuilding(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          // console.log(error, 'list devices')
          setLoading(false);
      }
  }

      const getDeviceTypes = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_camera_type`)
          // console.log(response)
          if(response.status === 200){
            setDeviceList(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          // console.log(error, 'list devices')
          setLoading(false);
      }
  }
  
    useEffect(() => {
      getAllVisitors();
      getDeviceTypes()
    }, []);


      const handlePersonalDetails = (e, name) => {
        if (name) {
          setPersonalDetailsData((prev) => {
            return {
              ...prev,
              [name]: e,
            };
          });
          seterrtext((prev) => {
            return {
              ...prev,
              PersonalDetailsData: {
                ...prev.PersonalDetailsData,
                [name]: "",
              },
            };
          });
        } else {
          const { name, value } = e.target;
          setPersonalDetailsData((prev) => {
            return {
              ...prev,
              [name]: value,
            };
          });
          seterrtext((prev) => {
            return {
              ...prev,
              PersonalDetailsData: {
                ...prev.PersonalDetailsData,
                [name]: "",
              },
            };
          });
        }
      };


      const saveDevice = async () => {
          setLoading(true)
          if(id){
             try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}update_device/${id}`, {
                  ...PersonalDetailsData
              })
              // console.log(response)
              if(response?.data?.status === 200){
                  // console.log('created')
                  toast.success("Device Updated Successfully")
                  setTimeout(() => {
                      navigate('/device_list')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              // console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          } else {
             try {
              const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}create_devices`, {
                  ...PersonalDetailsData
              })
              // console.log(response)
              if(response?.data?.status === 201){
                  // console.log('created')
                  toast.success("Device Created Successfully")
                  setTimeout(() => {
                      navigate('/device_list')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              // console.log(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          }
         
      }


  return (
      <>
      <ToastContainer
                  autoClose='3000'
                  position="bottom-center"
                  toastClassName="custom-toast"
                  hideProgressBar={true}
                />
    <Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Device Details</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Device Name</StyledTypography>
              <TextField
                name="name"
                value={PersonalDetailsData.name}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.name}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8}>
              <StyledTypography>IP</StyledTypography>
              <TextField
                name="ip"
                value={PersonalDetailsData.ip}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.ip
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.ip
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.ip}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>User Name</StyledTypography>
              <TextField
                name="user_name"
                value={PersonalDetailsData.user_name}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.user_name}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>
                Password
              </StyledTypography>
              <TextField
                name="password"
                value={PersonalDetailsData.password}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !No_special_regex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 25 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.password
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.password
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.password}
              </ErrorTypography>
            </Grid>

              <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Placement</StyledTypography>
              <Select
                name="device_placement"
                value={PersonalDetailsData.device_placement}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.device_placement
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.device_placement
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                <MenuItem value={`in`}>{`In`}</MenuItem>
                <MenuItem value={`out`}>{`Out`}</MenuItem>
                {/* {listBuilding.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.building_name}</MenuItem>;
                })} */}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.device_placement}
              </ErrorTypography>
            </Grid>

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Type</StyledTypography>
              <Select
                name="type"
                value={PersonalDetailsData.type}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.type
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {deviceList.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.title}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.type}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Port</StyledTypography>
              <TextField
                name="port"
                value={PersonalDetailsData.port}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.port}
              </ErrorTypography>
            </Grid> */}

          
            
           
          </Grid>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#E7EFF3" }}>Back</Button>
                    <Button type='button' disabled={loading} onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#E7EFF3" }}>{id ? "Update" : "Create"}</Button>
                </Stack>
            </Box>
        </Box>
        </>
  )
}

export default AddDevice